<template>
  <div>
    <span>
      <a-dropdown :trigger="['click']" :disabled="isMaintainer===0 && problemData.isHandler ===0">
        <span class="issue-status edit-status">
          <a-tag v-if="tagList && tagList[bugStatus]" :color="tagList[bugStatus].color">{{ tagList[bugStatus].label }}</a-tag>
          <a-icon class="icon-down" type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item v-for="(item, index) in tagList" :key="index" @click="onChange(item.value)">
            <a-tag :color="item.color">{{ item.label }}</a-tag>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </span>
  </div>
</template>
<script>
import { modifyTicketFlag } from '@/api/event/problem';

export default {
  components: { },
  props: {
    status: {
      type: [String, Number],
      default: null
    },
    isMaintainer: {
      type: Boolean,
      default: false
    },
    tagList: {
      type: Object,
      default: null
    },
    ticketId: {
      type: [String, Number],
      default: null
    },
    flag: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bugStatus: null
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.project_id) || this.project_id;
    }
  },
  mounted() {
    this.bugStatus = this.status;
  },
  methods: {
    onChange(value) {
    //   this.$refs.ticketStatusChangeModal.open(this.status, value);
      this.bugStatus = value;
      this.updateStatusAndComment();
    },
    updateStatusAndComment() {
      const req = {
        'id': this.ticketId,
        'handler': '',
        'maintainer': '',
        'tags': '',
        'level': '',
        'status': '',
        'domain': ''
      };
      if (this.flag === 'status') {
        req.status = this.bugStatus;
      }
      if (this.flag === 'handler') {
        req.handler = this.bugStatus;
      }
      if (this.flag === 'maintainer') {
        req.maintainer = this.bugStatus;
      }
      if (this.flag === 'tags') {
        req.tags = this.bugStatus;
      }
      if (this.flag === 'level') {
        req.level = this.bugStatus;
      }
      if (this.flag === 'domain') {
        req.domain = this.bugStatus;
      }
      modifyTicketFlag({ req }).then(() => {
        this.$emit('callback');
      });
    }
  }
};
</script>

    <style lang="less" scoped>
    .issue-status {
      cursor: pointer;
      display: inline-block;
      padding: 2px;
      padding-right: 2px;
      line-height: 22px;
      border-radius: 4px;
      .ant-tag {
        margin-right: 2px;
      }
      .icon-down {
        opacity: 0;
      }
    }

    .edit-status:hover {
      cursor: pointer;
      background-color: #e4e4e4;
      .icon-down {
        opacity: 1;
      }
    }
    </style>

